import { motion } from "framer-motion";
import { FadeInOut } from "../../../../Util/animations/Animations_v2";
import { useContext } from "react";
import { AppContext } from "../../../../Util/contexts/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCheck,
  faQuestionCircle,
} from "@fortawesome/pro-solid-svg-icons";
import MDSpinner from "react-md-spinner";

const GradingNav = ({
  closeGrading,
  gradingData,
  reviewLaterLoading,
  setReviewLaterLoading,
}) => {
  const { userData, fetchMarkReviewLater, reviewLaterExams } =
    useContext(AppContext);
  const isExamMarkedReviewLater = reviewLaterExams[gradingData.examId] === true;

  const handleReviewLaterClick = async () => {
    setReviewLaterLoading(true);
    await fetchMarkReviewLater(
      gradingData.examId,
      null,
      !isExamMarkedReviewLater
    );
    setReviewLaterLoading(false);
  };

  return (
    <motion.div
      className="newGradingBackWrapper"
      {...FadeInOut(userData.AnimationDisabled, 0.2)}
      key="newGradingBackWrapper"
    >
      <button
        className="tertiaryButton newGradingBackButton"
        onClick={closeGrading}
      >
        <FontAwesomeIcon icon={faArrowLeft} className="newGradingBackIcon" />
        Back To Exam List
      </button>
      <div
        className="newGradingCheckboxContainer"
        onClick={handleReviewLaterClick}
        style={{ gridTemplateColumns: "30px auto" }}
      >
        <div className="newGradingCheckbox">
          {isExamMarkedReviewLater && (
            <FontAwesomeIcon
              icon={faCheck}
              className="newGradingCheckboxIcon"
            />
          )}
        </div>
        <p className="newGradingCheckboxText">Review Later</p>
        {reviewLaterLoading && (
          <div className="reviewLaterLoadingContainer">
            <MDSpinner size={30} singleColor={"#fff"} />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default GradingNav;
